module.exports = __webpack_public_path__ + "static/tabaxi-1-4f0c6ee79f1fd49cf6f9d8d47e6c2b67.jpg";